import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const Error = styled.p `
  color: ${theme.palette.error.main};
  font-size: 0.75rem;
  margin: 0;
`;
